export default "__VITE_ASSET__h1UwM_Hu__"